import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Icon } from 'edcom-ui';
import styles from './FilterChips.module.less';

export default function FilterChips({
  clickFilterChip,
  handleClearAllClick,
  selectedFilters = [],
  hasClearAllBtn = true,
  contentRequestInProcess,
  queries,
  urlPath,
}) {
  const clearAllChip = (
    <div
      className={clsx(styles.chipClearAll)}
      title={'Clear All'}
      onClick={handleClearAllClick}
    >
      <a>Clear All</a>
    </div>
  );

  let clearableChipCount = 0;
  const renderFilterChips = selectedFilters.map(element => {
    const name = element.selectedAttribute.name;
    // Display filter name (e.g. Common Core, English Language Support) if attribute is 'Yes'
    const displayName = name === 'Yes' ? element.name : name;
    const title = `Remove filter: ${displayName.toUpperCase()}`;
    const keyName = element.name + '-' + name;
    const remove = () => clickFilterChip(element.selectedAttribute.href);

    if (element.name !== 'Subjects') {
      clearableChipCount++;
    }

    return (
      <div
        className={clsx(
          styles.chip,
          contentRequestInProcess && styles.disabled
        )}
        title={title}
        onClick={remove}
        key={`remove-filter-${keyName.replaceAll(' ', '-')}`}
        role="link"
        data-cy="filter-chip"
      >
        <div className={styles.chipText}>{displayName}</div>
        <Icon name="cancel-thin" className={styles.cancel} />
      </div>
    );
  });

  // Chip for showing query
  const createQueryChip = query => {
    if (!query) {
      return null;
    }

    var displayName = 'Search for: ' + query.trim().replaceAll(' ', ', ');

    return (
      <div
        className={clsx(
          styles.chip,
          contentRequestInProcess && styles.disabled
        )}
        title={`Remove query: ${displayName.toUpperCase()}`}
        onClick={() => clickFilterChip(urlPath, true)}
        key={`remove-query-filter`}
        role="link"
      >
        <div className={styles.chipText}>{displayName}</div>
        <Icon name="cancel-thin" className={styles.cancel} />
      </div>
    );
  };

  renderFilterChips.unshift(createQueryChip(queries));

  // Only display Clear All chip when a filter chip is visible
  if (hasClearAllBtn && clearableChipCount > 0) {
    renderFilterChips.push(clearAllChip);
  }

  return <>{renderFilterChips}</>;
}

FilterChips.propTypes = {
  clickFilterChip: PropTypes.func,
  handleClearAllClick: PropTypes.func,
  selectedFilters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      attributes: PropTypes.array,
      selectedAttribute: PropTypes.shape({
        urlSlice: PropTypes.string,
        href: PropTypes.string,
        name: PropTypes.string,
      }),
    })
  ),
  hasClearAllBtn: PropTypes.bool,
  contentRequestInProcess: PropTypes.bool,
  queries: PropTypes.string,
  urlPath: PropTypes.string,
};
